import Vue from 'vue';
import * as types from '@/store/mutation-types';

export default {
  [types.setInspectionTemplateList](state, list) {
    Vue.set(state, 'currentProjectInspectionTemplates', list);
  },
  [types.setInspectionTemplateProperties](state, update) {
    Object.assign(update.updateInspectionTemplate, update.newInspectionTemplateProperties);
  },
  [types.addInspectionTemplate](state, { newInspectionTemplate }) {
    if (!state.currentProject || !state.currentProject._id === newInspectionTemplate.projectId) {
      return;
    }
    if (!state.currentProjectInspectionTemplates.find((p) => p._id === newInspectionTemplate._id)) {
      state.currentProjectInspectionTemplates.push(newInspectionTemplate);
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/inspection/inspectionTemplateMutations.js